import { getDataFromServer } from '../../../util';
import moment from 'moment';

export class ModelListModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchModelList = async (payload) => {
    const params = {
      metaName: 'model'
    };

    const url = `${this.baseURL}/meta`;
    const data = await getDataFromServer(url, this.httpHeaders, params);
    if (Array.isArray(data) && data.length > 0) {
      let sortedData = [...data];
      sortedData.sort(
        (a, b) =>
          moment(String(a).split('_')[0]).format('YYYY-MM-DD') -
          moment(String(b).split('_')[0]).format('YYYY-MM-DD')
      );

      return sortedData.map((modelItem, modelIndex) => {
        const modelItemArray = String(modelItem).split('_');
        return {
          label: modelItem
            ? `${modelItemArray[0]}_model${sortedData.length - modelIndex}`
            : '-',
          value: modelItem ? String(modelItem).split('_')[1] : '-'
        };
      });
    }

    return [];
  };
}
